const initialState = {
  data: null,
};

const SET_CLIENT_TYPE = 'SET_CLIENT_TYPE';

export const setClientTypes = (payload) => ({
  type: SET_CLIENT_TYPE,
  payload,
});

export default function clientTypesReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CLIENT_TYPE:
      return { ...state, data: action.payload.data.data };
      default:
      return state;
  }
}
